import { create } from "zustand";

export const useRiskTreatmentStore = create((set) => ({
    // State
    data: [],
    loading: false,
    error: null,
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false,
    },
    searchQuery: "",
    sorting: {
        sortBy: 'createdAt',
        sortDirection: 'desc'
    },
    columnFilters: {},
    uniqueValues: {},

    // Pure State Mutations
    setRiskTreatments: (data) => set({ data }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setPagination: (pagination) => set({ pagination }),
    setSearchQuery: (searchQuery) => set({ searchQuery }),
    setSorting: (sorting) => set((state) => ({ sorting: { ...state.sorting, ...sorting } })),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),

    // UI Actions
    currentRiskTreatment: null,
    isFormOpen: false,
    isEditing: false,

    setCurrentRiskTreatment: (item) => set({ currentRiskTreatment: item }),
    openForm: (item = null) => set({
        isFormOpen: true,
        isEditing: !!item,
        currentRiskTreatment: item
    }),
    closeForm: () => set({
        isFormOpen: false,
        isEditing: false,
        currentRiskTreatment: null
    }),
}));
